import { render, staticRenderFns } from "./MyBtn.vue?vue&type=template&id=48769d92&scoped=true&"
import script from "./MyBtn.vue?vue&type=script&lang=js&"
export * from "./MyBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48769d92",
  null
  
)

export default component.exports